// Catálogo completo de errores HTTP 400–599
// Cada entrada: { title, message, hint }

const ERROR_CODES = {
  // ── 4xx Client Errors ──────────────────────────────────────────────
  400: {
    title: "Solicitud incorrecta",
    message:
      "La solicitud enviada al servidor contiene una sintaxis inválida o no puede ser procesada. Comprueba los parámetros e inténtalo de nuevo.",
    hint: "Bad Request",
  },
  401: {
    title: "No autorizado",
    message:
      "Necesitas identificarte antes de acceder a este recurso. Inicia sesión con tus credenciales y vuelve a intentarlo.",
    hint: "Unauthorized",
  },
  402: {
    title: "Pago requerido",
    message:
      "El acceso a este recurso requiere un pago previo o una suscripción activa. Revisa tu cuenta y estado de facturación.",
    hint: "Payment Required",
  },
  403: {
    title: "Acceso prohibido",
    message:
      "No tienes permiso para acceder a este recurso. Si crees que es un error, contacta con el administrador del sistema.",
    hint: "Forbidden",
  },
  404: {
    title: "Página no encontrada",
    message:
      "Esta coordenada no existe en nuestros mapas estelares. La página pudo haber sido movida, eliminada, o simplemente nunca existió en este universo.",
    hint: "Not Found",
  },
  405: {
    title: "Método no permitido",
    message:
      "El método HTTP utilizado no está permitido para este recurso. Verifica que estás usando el método correcto (GET, POST, PUT…).",
    hint: "Method Not Allowed",
  },
  406: {
    title: "No aceptable",
    message:
      "El servidor no puede generar una respuesta que coincida con los criterios aceptables indicados en la solicitud.",
    hint: "Not Acceptable",
  },
  407: {
    title: "Autenticación de proxy requerida",
    message:
      "Necesitas autenticarte con el servidor proxy para continuar. Verifica la configuración de red de tu dispositivo.",
    hint: "Proxy Authentication Required",
  },
  408: {
    title: "Tiempo de espera agotado",
    message:
      "El servidor tardó demasiado en recibir la solicitud completa. Comprueba tu conexión a internet e inténtalo de nuevo.",
    hint: "Request Timeout",
  },
  409: {
    title: "Conflicto de estado",
    message:
      "La solicitud no puede completarse porque hay un conflicto con el estado actual del recurso en el servidor.",
    hint: "Conflict",
  },
  410: {
    title: "Recurso eliminado",
    message:
      "El recurso solicitado ha sido eliminado permanentemente del servidor y no volverá a estar disponible en esta ruta.",
    hint: "Gone",
  },
  411: {
    title: "Longitud requerida",
    message:
      "El servidor rechaza la solicitud porque no se especificó la longitud del contenido. Incluye el header Content-Length.",
    hint: "Length Required",
  },
  412: {
    title: "Precondición fallida",
    message:
      "Una o más condiciones previas indicadas en los headers de la solicitud han sido evaluadas como falsas por el servidor.",
    hint: "Precondition Failed",
  },
  413: {
    title: "Contenido demasiado grande",
    message:
      "El tamaño de la solicitud supera el límite permitido por el servidor. Reduce el tamaño del archivo o los datos enviados.",
    hint: "Content Too Large",
  },
  414: {
    title: "URI demasiado larga",
    message:
      "La URL de la solicitud es demasiado larga para ser procesada por el servidor. Simplifica los parámetros de búsqueda.",
    hint: "URI Too Long",
  },
  415: {
    title: "Tipo de medio no soportado",
    message:
      "El servidor no admite el formato del contenido enviado. Verifica que el tipo MIME sea compatible con este endpoint.",
    hint: "Unsupported Media Type",
  },
  416: {
    title: "Rango no satisfacible",
    message:
      "El servidor no puede servir el rango de datos solicitado. El archivo puede ser más pequeño de lo esperado.",
    hint: "Range Not Satisfiable",
  },
  417: {
    title: "Expectativa fallida",
    message:
      "El servidor no puede cumplir los requisitos indicados en el header Expect de la solicitud.",
    hint: "Expectation Failed",
  },
  418: {
    title: "Soy una tetera",
    message:
      "Me niego a preparar café porque soy una tetera. Este es un código de broma del protocolo HTCPCP. ¡Pero tú lo encontraste!",
    hint: "I'm a Teapot",
  },
  421: {
    title: "Solicitud mal dirigida",
    message:
      "La solicitud fue dirigida a un servidor que no puede producir una respuesta. Verifica la configuración del servidor.",
    hint: "Misdirected Request",
  },
  422: {
    title: "Contenido no procesable",
    message:
      "El servidor entiende el tipo de contenido pero no puede procesar las instrucciones semánticas de la solicitud.",
    hint: "Unprocessable Content",
  },
  423: {
    title: "Recurso bloqueado",
    message:
      "El recurso al que intentas acceder está bloqueado. Otro proceso tiene un bloqueo activo sobre este recurso.",
    hint: "Locked",
  },
  424: {
    title: "Dependencia fallida",
    message:
      "La solicitud falló porque dependía de otra solicitud que también falló. Revisa el flujo completo de operaciones.",
    hint: "Failed Dependency",
  },
  425: {
    title: "Demasiado pronto",
    message:
      "El servidor no está dispuesto a procesar esta solicitud porque podría ser reenviada. Espera un momento y reintenta.",
    hint: "Too Early",
  },
  426: {
    title: "Actualización requerida",
    message:
      "El servidor requiere que el cliente actualice el protocolo. Puede que necesites usar HTTPS u otro protocolo compatible.",
    hint: "Upgrade Required",
  },
  428: {
    title: "Precondición requerida",
    message:
      "El servidor requiere que la solicitud sea condicional para evitar el problema del 'update perdido'. Incluye las condiciones necesarias.",
    hint: "Precondition Required",
  },
  429: {
    title: "Demasiadas solicitudes",
    message:
      "Has enviado demasiadas solicitudes en un período de tiempo muy corto. Espera unos segundos antes de volver a intentarlo.",
    hint: "Too Many Requests",
  },
  431: {
    title: "Headers demasiado grandes",
    message:
      "El servidor rechaza la solicitud porque los campos del header son demasiado grandes. Limpia las cookies o reduce los headers.",
    hint: "Request Header Fields Too Large",
  },
  451: {
    title: "No disponible por razones legales",
    message:
      "Este contenido no está disponible en tu región por restricciones legales o de cumplimiento normativo.",
    hint: "Unavailable For Legal Reasons",
  },

  // ── 5xx Server Errors ──────────────────────────────────────────────
  500: {
    title: "Error interno del servidor",
    message:
      "Algo ha fallado en el interior de nuestros sistemas. Nuestro equipo ya está trabajando en ello. Inténtalo de nuevo en unos minutos.",
    hint: "Internal Server Error",
  },
  501: {
    title: "No implementado",
    message:
      "El servidor no reconoce el método de solicitud y no puede soportarlo. Esta funcionalidad todavía no está disponible.",
    hint: "Not Implemented",
  },
  502: {
    title: "Puerta de enlace incorrecta",
    message:
      "El servidor recibió una respuesta inválida de un servidor upstream. Los servicios pueden estar reiniciándose, espera un momento.",
    hint: "Bad Gateway",
  },
  503: {
    title: "Servicio no disponible",
    message:
      "El servidor está temporalmente fuera de servicio, probablemente por mantenimiento o sobrecarga. Vuelve a intentarlo pronto.",
    hint: "Service Unavailable",
  },
  504: {
    title: "Tiempo de espera de puerta de enlace",
    message:
      "El servidor no recibió una respuesta a tiempo de un servidor upstream. Es un problema temporal, inténtalo de nuevo.",
    hint: "Gateway Timeout",
  },
  505: {
    title: "Versión HTTP no soportada",
    message:
      "El servidor no soporta la versión del protocolo HTTP utilizada en la solicitud.",
    hint: "HTTP Version Not Supported",
  },
  506: {
    title: "Variante también negocia",
    message:
      "El servidor tiene un error de configuración interno en la negociación de contenido transparente.",
    hint: "Variant Also Negotiates",
  },
  507: {
    title: "Almacenamiento insuficiente",
    message:
      "El servidor no puede almacenar la representación necesaria para completar la solicitud. El espacio en disco puede estar lleno.",
    hint: "Insufficient Storage",
  },
  508: {
    title: "Bucle detectado",
    message:
      "El servidor detectó un bucle infinito al procesar la solicitud. Hay una referencia circular en la configuración.",
    hint: "Loop Detected",
  },
  510: {
    title: "Extensión requerida",
    message:
      "El servidor requiere extensiones adicionales para procesar esta solicitud que el cliente no ha indicado.",
    hint: "Not Extended",
  },
  511: {
    title: "Autenticación de red requerida",
    message:
      "Necesitas autenticarte en la red para acceder a internet. Puede que estés conectado a una red con portal cautivo.",
    hint: "Network Authentication Required",
  },
};

// Fallback genérico para códigos no listados
export const getErrorInfo = (statusCode) => {
  const code = parseInt(statusCode, 10);
  if (ERROR_CODES[code]) return { code, ...ERROR_CODES[code] };

  // Fallbacks por familia
  if (code >= 400 && code < 500) {
    return {
      code,
      title: "Error del cliente",
      message:
        "Se ha producido un error en la solicitud. Verifica los datos enviados e inténtalo de nuevo.",
      hint: `Client Error ${code}`,
    };
  }
  if (code >= 500 && code < 600) {
    return {
      code,
      title: "Error del servidor",
      message:
        "Se ha producido un error inesperado en el servidor. Nuestro equipo ha sido notificado.",
      hint: `Server Error ${code}`,
    };
  }

  // Desconocido total
  return {
    code: code || 500,
    title: "Error desconocido",
    message:
      "Se ha producido un error inesperado. Por favor, inténtalo de nuevo o contacta con soporte.",
    hint: "Unknown Error",
  };
};

export default ERROR_CODES;
